import { ExternalLink } from "lucide-react";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ActionButton({
  href,
  onClick,
  icon: Icon = ExternalLink,
  label,
  variant = "primary",
  disabled = false,
  className,
  iconClassName,
  title,
  download = false,
}) {
  const base =
    "inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl text-xs font-black uppercase tracking-widest transition-all active:scale-[0.98] select-none";

  const variants = {
    primary:
      "bg-indigo-600 hover:bg-indigo-700 text-white shadow-xl shadow-indigo-600/20",
    subtle:
      "bg-white/5 hover:bg-white/10 text-slate-200 border border-white/10 dark:border-white/10",
    light:
      "bg-slate-100 hover:bg-slate-200 text-slate-900 border border-slate-200 dark:bg-white/5 dark:hover:bg-white/10 dark:text-slate-200 dark:border-white/10",
    danger:
      "bg-orange-600 hover:bg-orange-700 text-white shadow-xl shadow-orange-600/20",
  };

  const cls = cx(
    base,
    variants[variant],
    disabled && "opacity-50 pointer-events-none",
    className
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        download={download || undefined}
        className={cls}
        aria-label={label}
        title={title || label}
      >
        <Icon className={cx("w-4 h-4", iconClassName)} />
        {label}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cls}
      disabled={disabled}
      aria-label={label}
      title={title || label}
    >
      <Icon className={cx("w-4 h-4", iconClassName)} />
      {label}
    </button>
  );
}

